var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-inline-flex dropdown" }, [
    _c(
      "h5",
      {
        staticClass: "mb-0",
        class: { "dropdown-toggle clickable": _vm.isMultiLinked },
        attrs: { "data-toggle": _vm.isMultiLinked ? "dropdown" : null },
      },
      [
        _vm._v(
          "\n    " +
            _vm._s(_vm._f("fullName")(_vm.selectedLinkedProfile)) +
            "\n  "
        ),
      ]
    ),
    _vm._v(" "),
    _vm.isMultiLinked
      ? _c(
          "div",
          { staticClass: "dropdown-menu" },
          _vm._l(_vm.linkedProfilesWithoutCurrent, function (linkedProfile) {
            return _c(
              "div",
              {
                key: linkedProfile.clientProfileId,
                staticClass: "clickable text-grey dropdown-item pb-2 mb-1",
                on: {
                  click: function ($event) {
                    return _vm.handleProfileSelection(
                      linkedProfile.clientProfileId
                    )
                  },
                },
              },
              [
                _c("p", { staticClass: "bold mb-0" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("fullName")(linkedProfile)) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "font-md mb-0 text-truncate" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm._f("boardName")(linkedProfile.boardId, _vm.boards)
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "font-sm mb-0" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("formatMoneyValue")(linkedProfile.value)) +
                      "\n      "
                  ),
                ]),
              ]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }